// @ts-nocheck
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import Pagination from "@insite/mobius/Pagination";
import updateShipTosPagination from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/UpdateShipTosPagination";
import { DataViewResult } from "@toolkit/Framework/Store/Data/DataState";
import { FC } from "react";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    dataView: DataViewResult<ShipToModel[]>;
}

const mapDispatchToProps = {
    updateShipTosPagination,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

const StoreListsShipTosPagination: FC<Props> = ({ dataView, updateShipTosPagination }) => {
    const onChangePage = (newPageIndex: number) => {
        updateShipTosPagination({ page: newPageIndex });
    };

    const onChangeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {};

    const { pagination } = dataView;

    if (!pagination) {
        return <></>;
    }

    return (
        <Pagination
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={onChangePage}
            onChangeResultsPerPage={onChangeResultsPerPage}
        />
    );
};

export default connect(null, mapDispatchToProps)(StoreListsShipTosPagination);
